import { render, staticRenderFns } from "./UploadDocumentModal.vue?vue&type=template&id=4bfdc16c"
import script from "./UploadDocumentModal.vue?vue&type=script&lang=js"
export * from "./UploadDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports